import { useEffect, useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { api, startCheckout } from "@/lib/api";
import { isIOSApp } from "@/lib/native";

export const PlanCards = ({ onSelect, currentPlan, dark = false }) => {
  const [plans, setPlans] = useState([]);
  const [busy, setBusy] = useState(null);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)); }, []);
  if (isIOSApp) return (
    <p data-testid="ios-membership-note" className="rounded-md border border-stone-200 bg-white p-6 text-sm text-stone-600">
      Memberships can't be purchased in the iPhone app. If you already have a membership, it's available here automatically after you sign in.
    </p>
  );

  const choose = async (p) => {
    setBusy(p.id);
    if (onSelect) await onSelect(p);
    else await startCheckout(p.id);
    setBusy(null);
  };

  return (
    <div className="grid gap-6 md:grid-cols-3">
      {plans.map((p) => {
        const featured = p.popular;
        const current = currentPlan === p.id;
        return (
          <div
            key={p.id}
            data-testid={`plan-card-${p.id}`}
            className={`lift relative flex flex-col rounded-md border p-8 ${featured ? "border-slate-900 bg-slate-900 text-white" : dark ? "border-stone-700 bg-stone-900 text-white" : "border-stone-200 bg-white"}`}
          >
            {featured && <span className="absolute -top-3 left-8 rounded-full bg-amber-500 px-3 py-0.5 text-[10px] font-mono uppercase tracking-wider text-slate-900">Most popular</span>}
            <p className="font-display text-xl font-bold">{p.name}</p>
            <p className={`mt-1 text-sm ${featured ? "text-stone-300" : "text-stone-500"}`}>{p.tagline}</p>
            <p className="mt-6 font-display text-5xl font-extrabold tracking-tight">
              ${p.price.toFixed(0)}<span className={`text-base font-medium ${featured ? "text-stone-400" : "text-stone-500"}`}> {p.currency.toUpperCase()}/mo</span>
            </p>
            <ul className="mt-6 flex-1 space-y-3">
              {p.features.map((f) => (
                <li key={f} className="flex gap-2.5 text-sm"><Check className={`mt-0.5 h-4 w-4 shrink-0 ${featured ? "text-amber-400" : "text-emerald-600"}`} />{f}</li>
              ))}
            </ul>
            <button
              data-testid={`plan-select-${p.id}`}
              disabled={busy === p.id || current}
              onClick={() => choose(p)}
              className={`mt-8 inline-flex items-center justify-center gap-2 rounded-md px-4 py-3 text-sm font-medium transition-colors disabled:opacity-60 ${featured ? "bg-white text-slate-900 hover:bg-amber-400" : "bg-slate-900 text-white hover:bg-slate-700"}`}
            >
              {busy === p.id && <Loader2 className="h-4 w-4 animate-spin" />}
              {current ? "Current plan" : `Choose ${p.name}`}
            </button>
          </div>
        );
      })}
    </div>
  );
};
